const options = {
  loop: true,
  spaceBetween: 24,
  breakpoints: {
    768: {
      spaceBetween: 48,
    },
  },
};

const selectorBulletPagination = `.swiper.swiper--bullet-pagination`;
const selectorVariableWidth = `.swiper.swiper--variable-width`;
const selectorNavigationNextButton = `[data-custom-swiper-next-control]`;
const selectorNavigationPrevButton = `[data-custom-swiper-prev-control]`;

export {
  options,
  selectorBulletPagination,
  selectorVariableWidth,
  selectorNavigationNextButton,
  selectorNavigationPrevButton
};
